export default __webpack_public_path__ + "static/media/school-generateImg.69d2719c.png";